import { useCallback } from 'react'
import dayjs from 'dayjs'

export function useDateChangeHandler<T>(
  setFieldValue: (field: string, value: Date | null, shouldValidate?: boolean) => void
) {
  return useCallback(
    (fieldName: keyof T) => (date: dayjs.Dayjs | Date | null) => {
      setFieldValue(fieldName as string, date && dayjs(date).isValid() ? dayjs(date).toDate() : null)
    },
    [setFieldValue]
  )
}
